import React, { useContext, useEffect, useRef, useState } from "react";
import WelletContext from "../../context/WelletContext";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  skeletonEmptyPerformances,
  skeletonSchedule,
} from "../../components/Skeletons/SkeletonRestaurantReservation";
import {
  generateDisabledDates,
  getDateFromOffset,
  getLocale,
} from "../../helpers/dates";
import { useParams } from "react-router-dom";
import { convertTime12to24 } from "../../helpers/dates";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { setReservation } from "../../actions/reservationActions";
import ReservationSelector from "../../components/ReservationSelector/ReservationSelector";
import EmptyActivity from "../../components/Common/EmptyActivity/EmptyActivity";
import Calendar from "../../components/Common/Calendar/Calendar";
import Button from "../../components/Common/Button/Button";
import styles from "./reservation.module.css";
import ProductModal from "../../components/Common/ProductModal/ProductModal";
import Header from "../../components/Header/Header";
import ProductPerformanceSelector from "../../components/ProductPerformanceSelector/ProductPerformanceSelector";
import FixedButton from "../../components/Common/FixedButton/FixedButton";
import "./reservation.css";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import { setReservationType } from "../../actions/reservationActions";
import ContentApp from "../../components/ContentApp/ContentApp";
import { lockSchedule } from "../../services/reservations/reservationsService";
import ErrorBox from "../../components/ErrorBox/ErrorBox";
import { setAvailableTime } from "../../actions/timerActions";
import SeatsAvailableOpenTable from "../../components/Common/SeatsAvailableOpenTable/SeatsAvailableOpenTable";
import axios from "axios";

const Reservation = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showUrl } = useParams();
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);
  const language = useSelector((state) => state.app.language);
  const locale = getLocale(language);
  const calendarRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(null);
  const [today, setToday] = useState(null);
  const [compareToday, setCompareToday] = useState(null);
  const [minDate, setMinDate] = useState(new Date());
  const [disabledDates, setDisabledDates] = useState([]);
  const [loadingSchedule, setLoadingSchedule] = useState(false);
  const [scheduleNotAvailable, setScheduleNotAvailable] = useState(false);
  const [selectDisabled, setSelectDisabled] = useState(false);
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [intervals, setIntervals] = useState([]);
  const [hasCallCenter, setHasCallCenter] = useState(null);
  const [externalPlaftorm, setExternalPlaftorm] = useState();
  const reservationTypeRestaurant = "RESTAURANT";
  const seatInfoReservation = useSelector(
    (state) => state?.reservation?.attribute
  );
  const [selectedSeatType, setSelectedSeatType] = useState(
    seatInfoReservation || null
  );
  const reservationInfoPaxs = useSelector((state) => state?.reservation?.paxs);
  const [selectedPax, setSelectedPax] = useState(reservationInfoPaxs || 2);
  const CancelToken = axios.CancelToken;
  let cancelSchedulePrevious;
  const safeLocalDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  const reservationInfoDate = useSelector((state) => state?.reservation?.date);

  const [selectedDate, setSelectedDate] = useState(
    reservationInfoDate ? safeLocalDate(reservationInfoDate) : null
  );

  const reservationInfoPerformance = useSelector(
    (state) => state?.reservation?.performance
  );

  const [selectedPerformance, setSelectedPerformance] = useState(
    reservationInfoPerformance || null
  );

  const addMinutes = (date, minutes) => {
    let result = new Date(date);
    result.setMinutes(date.getMinutes() + minutes);
    return result;
  };

  const getExternalPlatform = async () => {
    try {
      const result = await welletContext.apis.tickets.get(
        `/shows/${show.id}/external-plaftorm/config?reservationType=RESTAURANT`
      );

      setExternalPlaftorm(result.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getShow = async () => {
    try {
      const result = await welletContext.apis.tickets.get(
        `/shows/get/${showUrl}`,
        {
          params: {
            lang: language,
          },
        }
      );

      setShow(result.data);
      const todayDate = new Date(getDateFromOffset(result.data.utcOffset));
      const yesterdayDate = new Date(todayDate);
      yesterdayDate.setDate(yesterdayDate.getDate() - 1);
      const firstDate = new Date(
        todayDate.getFullYear(),
        todayDate.getMonth(),
        1
      );
      setToday(todayDate);
      setCompareToday(addMinutes(todayDate, 20));
      setMinDate(
        new Date(todayDate.getFullYear(), todayDate.getMonth(), 0 + 1)
      );
      setDisabledDates(generateDisabledDates(firstDate, yesterdayDate, locale));
      if (!selectedDate) {
        setSelectedDate(todayDate);
      }

      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const getSchedule = async (date, reservationType) => {
    const formatedDate = format(date, "yyyy-MM-dd");
    setLoadingSchedule(true);
    if (
      cancelSchedulePrevious &&
      typeof cancelSchedulePrevious === "function"
    ) {
      cancelSchedulePrevious("Cancel previous schedule request");
    }

    try {
      const result = await welletContext.apis.tickets.get(
        `/shows/GetSchedule?showId=${show.id}&date=${formatedDate}&reservationType=${reservationType}&paxs=${selectedPax}`,
        {
          cancelToken: new CancelToken(function executor(c) {
            cancelSchedulePrevious = c;
          }),
        }
      );
      if (result.data.length === 0) {
        setIntervals([]);
      }
      const rawSchedules = result.data?.schedules || [];
      const formattedTimes = rawSchedules.map((time) => {
        const time24 = new Date(
          format(date, "yyyy-MM-dd") + "T" + convertTime12to24(time.timeStart)
        );
        return {
          time24,
          soldOut: time.isSoldOut,
          attributes: time.attributes,
          originalData: time,
        };
      });
      formattedTimes.sort((a, b) => a.time24 - b.time24);
      const allIntervals = formattedTimes.map(
        ({ time24, soldOut, attributes, originalData }) => ({
          time: time24,
          soldOut,
          attributes,
          originalData,
        })
      );
      setIntervals(allIntervals);
      setLoadingSchedule(false);
    } catch (error) {
      if (axios.isCancel(error)) return;
      console.error(error);
    } finally {
      setLoadingSchedule(false);
    }
  };

  const enableSelect = () => {
    setSelectDisabled(false);
  };

  const handleChangeDate = async (day) => {
    setSelectedPerformance(null);
    if (day !== undefined) {
      setSelectedDate(day);
      getSchedule(day, "RESTAURANT", show.id);
    }
    setCalendarVisible(!calendarVisible);
  };

  const onSelectPerformance = (performance) => {
    setSelectedPerformance(performance);
    setScheduleNotAvailable(false);
  };

  const handleSeatChange = (seatValue) => {
    setSelectedSeatType(seatValue);
  };

  const getFilteredAndFormattedIntervals = () => {
    const filteredIntervals = selectedSeatType
      ? intervals.filter((interval) =>
          interval.attributes?.includes(selectedSeatType)
        )
      : intervals;

    return filteredIntervals.map((interval) => ({
      ...interval,
      time: interval.time,
      soldOut: interval.soldOut,
    }));
  };

  const handleContinue = async () => {
    const reservationInfo = {
      show: show,
      showId: show.id,
      showName: show.name,
      products: null,
      performance: selectedPerformance,
      date: format(selectedDate, "yyyy-MM-dd"),
      paxs: selectedPax,
      callCenter: hasCallCenter,
      attribute: selectedSeatType,
    };

    dispatch(setReservation(reservationInfo));
    const restaurantReservation = show.reservationTypes?.find(
      (type) => type.type === "RESTAURANT" && type.hasExternalPlatform
    );

    if (restaurantReservation) {
      try {
        const result = await lockSchedule(welletContext, {
          pax: selectedPax,
          reservationDateLocalTime:
            format(selectedDate, "yyyy-MM-dd") + "T" + selectedPerformance,
          reservationType: "RESTAURANT",
          showId: show.id,
          attribute: selectedSeatType,
        });

        if (result?.success === false) {
          setScheduleNotAvailable(true);
          return;
        }
        dispatch(setAvailableTime(result?.expiresAt));
        if (result?.reservation_Token) {
          navigate(
            {
              pathname: `/venue/${showUrl}/reservation-check`,
              search: `?show=${show.name}&showId=${show.id}&reservationToken=${result.reservation_Token}&seats=${selectedSeatType}`,
            },
            {
              state: {
                hasExternalPlatform: !!externalPlaftorm,
              },
            }
          );
          return;
        }
      } catch (error) {
        console.error("Error locking schedule:", error);

        return;
      }
    }

    navigate(
      {
        pathname: `/venue/${showUrl}/reservation-check`,
      },
      {
        state: {
          hasExternalPlatform: !!externalPlaftorm,
        },
      }
    );
  };

  useEffect(() => {
    if (reservationInfoPerformance && intervals.length > 0) {
      const matchedPerformance = intervals.find(
        (interval) =>
          format(interval.time, "HH:mm") === reservationInfoPerformance
      );
      if (matchedPerformance) {
        setSelectedPerformance(format(matchedPerformance.time, "HH:mm"));
      }
    }
  }, [intervals, reservationInfoPerformance]);

  useEffect(() => {
    setSelectedPerformance(null);
  }, [selectedSeatType]);

  useEffect(() => {
    const reservation = show?.reservationTypes?.find(
      (item) =>
        item.type.toLowerCase() === reservationTypeRestaurant.toLowerCase()
    );

    if (reservation?.hasExternalPlatform) {
      getExternalPlatform();
    }

    if (show && show.reservationTypes && Array.isArray(show.reservationTypes)) {
      const reservation = show.reservationTypes.find(
        (item) =>
          item.type.toLowerCase() === reservationTypeRestaurant.toLowerCase()
      );
      if (reservation) {
        const hasCallCenter = reservation.hasCallCenter;
        setHasCallCenter(hasCallCenter);
        // dispatch(setReservationType(reservationTypeRestaurant));
      }
    }
  }, [show]);

  useEffect(() => {
    if (selectedDate && selectedPax && show) {
      getSchedule(selectedDate, reservationTypeRestaurant);
    }
    return () => {
      if (
        cancelSchedulePrevious &&
        typeof cancelSchedulePrevious === "function"
      ) {
        cancelSchedulePrevious("Cleanup on dependency change");
      }
    };
  }, [selectedDate, selectedPax]);

  useEffect(() => {
    if (!show) return;
    if (today !== null) {
      getSchedule(today, "RESTAURANT", show.id);
    }
  }, [today, show]);

  useEffect(() => {
    setSelectedSeatType(null);
  }, [selectedPax]);

  useEffect(() => {
    dispatch(setReservationType(reservationTypeRestaurant));
    getShow();
  }, []);

  return loading ? (
    <LoadingScreen />
  ) : (
    <div className="bottom-fixed">
      <Header
        title={
          <div className="text-capitalize px-3">
            {t("book") + " " + show.name}
          </div>
        }
      />
      <ContentApp>

      {!loading && compareToday !== null && selectedDate !== null ? (
        <>
          <div className="mt-4 ">
            <ReservationSelector
              selectedPax={selectedPax}
              setSelectedPax={setSelectedPax}
              selectedDate={selectedDate}
              selectDisabled={selectDisabled}
              enableSelect={enableSelect}
              handleChangeDate={handleChangeDate}
              loading={loadingSchedule}
              setCalendarVisible={setCalendarVisible}
              calendarVisible={calendarVisible}
              setSelectDisabled={setSelectDisabled}
              calendarRef={calendarRef}
              initialSlide={0}
            />
          </div>
          {externalPlaftorm && (
            <SeatsAvailableOpenTable
              selectedSeatType={selectedSeatType}
              intervals={intervals}
              onSeatChange={handleSeatChange}
            />
          )}
          <div className="mt-4">
            {!loadingSchedule ? (
              <>
                {intervals?.length > 0 && !loadingSchedule ? (
                  <div className="fade-up">
                    <div className="text-secondary fw-bold">
                      {t("selectTime")}
                    </div>
                    <div className="mt-3">
                      <ProductPerformanceSelector
                        performances={
                          externalPlaftorm?.showPowerBy
                            ? getFilteredAndFormattedIntervals()
                            : intervals
                        }
                        onSelect={onSelectPerformance}
                        selectedPerformance={selectedPerformance}
                        language={language}
                        selectedDate={selectedDate}
                        loadingSchedule={loadingSchedule}
                        today={compareToday}
                      />
                    </div>
                  </div>
                ) : !loadingSchedule ? (
                  <EmptyActivity
                    icon={"notification"}
                    title={"No hay horarios disponibles"}
                  />
                ) : (
                  skeletonSchedule()
                )}
              </>
            ) : (
              <>{skeletonEmptyPerformances()}</>
            )}
          </div>
          <FixedButton>
            <Button
              text={t("continue")}
              size="large"
              className={`mt-2 mb-2 ${styles.btn}`}
              onClick={handleContinue}
              icon={true}
              disabled={!selectedPax || !selectedPerformance}
              typeIcon="arrow"
              iconColor="#000"
            />
            {scheduleNotAvailable && (
              <div className=" mb-2">
                <ErrorBox title={t("scheduleIsNotAvailable")}> </ErrorBox>
              </div>
            )}
            {externalPlaftorm && (
              <div className="d-flex justify-content-center ">
                <div
                  className={`${styles.poweredByContainer} d-flex align-items-center`}
                >
                  <span className="semi-bold mr-1 font-smaller">
                    Powered by&nbsp;
                  </span>
                  <img
                    className={styles.containerImgLogoPlatform}
                    src={externalPlaftorm?.logoUrl}
                    alt="logo-restaurant"
                  />
                </div>
              </div>
            )}
          </FixedButton>
          </>
        ) : null}
      </ContentApp>
      <ProductModal
        open={calendarVisible}
        fullScreen={true}
        animationClass="fade-up-horizontal"
        hasBackground
        showCloseButton={false}
      >
        <ContentApp>
          <Header onClick={() => setCalendarVisible(false)} showBack />
          <Calendar
            minDate={minDate}
            disabledDates={disabledDates}
            onSelectDate={handleChangeDate}
            selectedDate={selectedDate}
          />
        </ContentApp>
      </ProductModal>
    </div>
  );
};

export default Reservation;
